const env = {
  REACT_APP_API_HOST: process.env.REACT_APP_API_HOST || "",
  /**
   * Host RIÊNG cho javis-loan-savings, dùng khi chạy service đó dưới local.
   *
   * Để rỗng (mặc định) thì module Quản lý tiền vay đi chung REACT_APP_API_HOST như mọi
   * service khác. Đặt giá trị (vd http://localhost:8085) thì CHỈ các API khoản vay trỏ về
   * máy local, còn đăng nhập / phiên / các nghiệp vụ khác vẫn gọi môi trường dev — nếu
   * trỏ toàn bộ REACT_APP_API_HOST về local thì mất luôn đăng nhập.
   */
  REACT_APP_LOAN_API_HOST: process.env.REACT_APP_LOAN_API_HOST || "",
  /**
   * Host RIÊNG cho javis-historical-service (API 10 — nhật ký thao tác khoản vay).
   *
   * Cùng cơ chế như REACT_APP_LOAN_API_HOST: để rỗng thì đi chung REACT_APP_API_HOST, đặt
   * http://localhost:8080 thì chỉ API nhật ký trỏ về local.
   *
   * ⚠️ Khi bật cái này, historical-service dưới local phải được cấu hình
   * DOMAIN_LOAN_SAVINGS=http://localhost:8085 — nó cần gọi ngược loan-service để đổi loanId
   * thành danh sách requestId, và cardtest KHÔNG mở endpoint internal của loan-service.
   */
  REACT_APP_HISTORICAL_API_HOST: process.env.REACT_APP_HISTORICAL_API_HOST || "",
  /**
   * Base URL của **API tích hợp JAVIS AI v1**. Các đường `/v1/chat/*` do
   * `services/javisAiChat.ts` tự nối, nên ở đây chỉ ghi tới phần gốc, không kèm `/v1`.
   *
   * Trỏ về **endpoint proxy của backend Javis BIZ** (backend gắn `X-API-Key` rồi chuyển tiếp), hoặc
   * thẳng tới JAVIS AI khi lập trình viên thử dưới local — xem javadoc của `javisAiChat.ts`.
   * Dịch vụ này KHÔNG nằm sau `REACT_APP_API_HOST` (envelope và kiểu response khác hẳn) nên khai riêng.
   */
  REACT_APP_AI_CHAT_HOST: process.env.REACT_APP_AI_CHAT_HOST || "",
  /** UUID của assistant đã publish, do team JAVIS AI cấp. Thiếu là mọi request bị từ chối. */
  REACT_APP_AI_ASSISTANT_ID: process.env.REACT_APP_AI_ASSISTANT_ID || "",
  /**
   * API Key `jvs_...`.
   *
   * ⚠️ **PHẢI để rỗng ở mọi bản build có người dùng thật.** Tài liệu tích hợp §1 quy định key chỉ
   * được giữ ở backend; đặt vào đây là key nằm trong bundle JavaScript, ai mở DevTools cũng lấy
   * được và tiêu hạn mức của Javis BIZ. Chỉ dùng khi chạy local để thử nhanh.
   */
  REACT_APP_AI_API_KEY: process.env.REACT_APP_AI_API_KEY || "",
  REACT_APP_SESSION_TIMEOUT:
    Number(process.env.REACT_APP_SESSION_TIMEOUT) || 3600000,
  SECRET_KEY: process.env.SECRET_KEY || "",
};
export default env;
